import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

// Serialize arrays as repeated params (sizes=a&sizes=b) for FastAPI List[str].
function repeatSerializer(params) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (Array.isArray(v)) v.forEach((x) => sp.append(k, x));
    else if (v != null && v !== '') sp.append(k, v);
  });
  return sp.toString();
}

export async function getAbandonedCarts({ days, date_from, date_to } = {}) {
  const params = {};
  if (days != null) params.days = days;
  if (date_from) params.date_from = date_from;
  if (date_to) params.date_to = date_to;
  const res = await axios.get(`${API}/messaging/abandoned-carts`, {
    headers: authHeader(), params,
  });
  return res.data;
}

export async function getSuggestions({ sizes, genders, categories, use_cases, brands, limit } = {}) {
  const res = await axios.get(`${API}/messaging/suggestions`, {
    headers: authHeader(),
    params: { sizes, genders, categories, use_cases, brands, limit },
    paramsSerializer: repeatSerializer,
  });
  return res.data;
}

export async function browseCatalog({ q, gender, size, category, use_case, brand, offset, limit } = {}) {
  const res = await axios.get(`${API}/messaging/catalog`, {
    headers: authHeader(),
    params: { q, gender, size, category, use_case, brand, offset, limit },
  });
  return res.data;
}

export async function markSent({ phone, design_codes, message } = {}) {
  const res = await axios.post(`${API}/messaging/mark-sent`,
    { phone, design_codes, message }, { headers: authHeader() });
  return res.data;
}

export async function unmarkSent(phone) {
  const res = await axios.post(`${API}/messaging/unmark-sent`,
    { phone }, { headers: authHeader() });
  return res.data;
}
